module.exports = __webpack_public_path__ + "static/media/img-3-en.61b34eca.webp";